/**
 * Generate an 8-character random string in the format XXXX-XXXX (e.g. 0000-0000).
 * Uses digits 0-9 for each segment.
 */
function generateAskString() {
  const digit = () => Math.floor(Math.random() * 10);
  const segment = () =>
    `${digit()}${digit()}${digit()}${digit()}`;
  return `${segment()}-${segment()}`;
}

export default generateAskString;
